import type { UpgradeCategory, UpgradeDef } from '../content/types';

/** Default glyph per upgrade category; an UpgradeDef may override with `icon`. */
export const CATEGORY_ICON: Record<UpgradeCategory, string> = {
  damage: '⚔',
  fireRate: '⚡',
  projectile: '➶',
  crit: '✦',
  health: '♥',
  sustain: '✚',
  mobility: '➤',
  economy: '◆',
  element: '❋',
  rule: '◉',
  evolution: '★',
};

const ELEMENT_ICON: Record<string, string> = { fire: '🔥', frost: '❄', lightning: '⚡', temporal: '⌛' };

export function upgradeIcon(u: UpgradeDef): string {
  if (u.icon) return u.icon;
  if (u.category === 'element') for (const t of u.tags ?? []) if (ELEMENT_ICON[t]) return ELEMENT_ICON[t];
  return CATEGORY_ICON[u.category] ?? '•';
}
